import { getActivePromotions } from "../webclients/promotion.client";
import { ActivePromotionResponse } from "../types/promotion.definition";

export const promotionApi = {
  getActivePromotions: async (
    facilityId: string | number
  ): Promise<ActivePromotionResponse[]> => {
    const response = await getActivePromotions(facilityId);
    return response.data;
  },
};
